var BookmarkView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

View = require('./base/view');

template = require('./templates/bookmark');

module.exports = BookmarkView = (function(_super) {
  __extends(BookmarkView, _super);

  function BookmarkView() {
    _ref = BookmarkView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  BookmarkView.prototype.template = template;

  BookmarkView.prototype.tagName = 'li';

  BookmarkView.prototype.className = 'item';

  BookmarkView.prototype.events = {
    'click': 'goToPage',
    'click .btn-delete': 'deleteBookmark'
  };

  BookmarkView.prototype.goToPage = function() {
    this.publishEvent('catalogue:goToPage', parseInt(this.model.get('page_num')));
    return false;
  };

  BookmarkView.prototype.deleteBookmark = function() {
    this.model.destroy();
    return false;
  };

  return BookmarkView;

})(View);
